module.exports = __webpack_public_path__ + "img/aball.6738cd20.png";